/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PolicyInfoPage, PolicyDetailsPage, OfferingsPage, LocationsPage, SuccessPage, DeclarationPage, RiskAnalysisPage, QuotePage } from 'premier-capability-policyjob-react';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';
// import QuotePage from './pages/Quote/QuotePage';
import PropertyCoveragesPage from './pages/PropertyCoverages/PropertyCoveragesPage';
import LiabilityCoveragesPage from './pages/LiabilityCoverages/LiabilityCoveragesPage';
import DronePage from './pages/Drone/DronePage';

setComponentMapOverrides(
    {
        // wizard pages
        PremierOfferingsPage: { component: 'PremierOfferingsPage'},
        PremierSRPolicyDetailsPage: {component: 'PremierSRPolicyDetailsPage'},
        PremierSRLocationsPage: {component: 'PremierSRLocationsPage'},
        PremierSRLiabilityCoveragesPage: {component: 'PremierSRLiabilityCoveragesPage'},
        PremierSRPropertyCoveragesPage: {component: 'PremierSRPropertyCoveragesPage'},
        PremierSRDronePage: {component: 'PremierSRDronePage'},
        PremierSRRiskAnalysisPage: { component: 'PremierSRRiskAnalysisPage'},
        PremierSRQuotePage: { component: 'PremierSRQuotePage' },
        PremierSRPolicyInfoPage: { component: 'PremierSRPolicyInfoPage' },
        PremierSRDeclarationPage: {component: 'PremierSRDeclarationPage'},
        PremierSRSuccessPage: { component: 'PremierSRSuccessPage' },
    },
    {
        // wizard pages
        PremierOfferingsPage: OfferingsPage,
        PremierSRPolicyDetailsPage: PolicyDetailsPage,
        PremierSRLocationsPage: LocationsPage,
        PremierSRLiabilityCoveragesPage: LiabilityCoveragesPage,
        PremierSRPropertyCoveragesPage: PropertyCoveragesPage,
        PremierSRDronePage: DronePage,
        PremierSRRiskAnalysisPage: RiskAnalysisPage,
        PremierSRQuotePage: QuotePage,
        PremierSRPolicyInfoPage: PolicyInfoPage,
        PremierSRDeclarationPage: DeclarationPage,
        PremierSRSuccessPage: SuccessPage,

    }
);
 
export { CodegenWizard, CodegenContext };
